import { put, takeLatest, fork, call } from "redux-saga/effects";
import { ActionType } from "models/contract/information";
import { IResponse } from "models";
import { httpStatus } from "configs/httpStatus";
import { fetchContractInformation } from "services/contractInformation";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./contractInformationActions";

function* contractInformationSaga() {
  try {
    const response: IResponse = yield call(fetchContractInformation);
    if (
      response.status === httpStatus.StatusCreated ||
      response.status === httpStatus.StatusOK
    ) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onContractInformationWatcher() {
  yield takeLatest(
    ActionType.CONTRACT_INFORMATION as any,
    contractInformationSaga
  );
}

export default [fork(onContractInformationWatcher)];
